/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

export function formatCycle(cycle: number) {
  return +cycle.toString().substr(4, 2);
}
